<template>
  <el-breadcrumb separator="/" class="breadcrumb-inner" style="display: inline-block;width: 100%;">
    <template v-for="(item,index) in breadcrumbList">
      <el-breadcrumb-item v-if="item.path && index !== breadcrumbList.length-1 && !item.noShowMenu" :to="{ path: item.path}">{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-else>{{item.name}}
        <el-button v-if="item.name === '生成兑换码'" @click="lastStep"
                   style="padding: 5px 10px;border: 1px solid #BFCAD1;border-radius: 4px;font-size: 14px;color: #022F4A;">
          返回上一步
        </el-button>
      </el-breadcrumb-item>
    </template>

  </el-breadcrumb>
</template>

<script>
    export default {
        name: "breadcrumb",
        props: {
          cMenus: {
            type: Array,
            required: true
          }
        },
        data () {
            return {
              menuLists: [],
              breadcrumbList: []
            }
        },
        watch: {
          '$route.path': function () {
              this.getBreadcrumbList();
          }
        },
        created() {
          this.menuLists = JSON.parse(JSON.stringify(this.cMenus));
          this.initBreadcrumbList();
          this.getBreadcrumbList();
        },
        methods: {
          initBreadcrumbList() {
            //组装面包屑
            function setBreadcrumb(array,breadcrumb) {
              array.forEach(item=>{
                if(item.children && item.children.length){
                  let childrenBreadcrumb = Object.assign([],breadcrumb);
                  if (item.meta.breadcrumb !== false) {
                    childrenBreadcrumb.push({
                      path: item.path,
                      name: item.name,
                      noShowMenu: item.meta.noShowMenu
                    });
                  }
                  item.breadcrumbNeste = childrenBreadcrumb;
                  setBreadcrumb(item.children,childrenBreadcrumb);
                }
                else {
                  let tmpBreadcrumb = Object.assign([],breadcrumb);
                  if (item.meta.breadcrumb !== false) {
                    tmpBreadcrumb.push({
                      path: item.path,
                      name: item.name,
                      noShowMenu: item.meta.noShowMenu
                    });
                  }
                  item.breadcrumbNeste = tmpBreadcrumb;
                }
              })
            }
            setBreadcrumb(this.menuLists,[]);
          },
          getBreadcrumbList() {
            let path = this.$route.path;
            //获取面包屑
            let self = this;
            self.breadcrumbList = [];
            function getBreadcrumb(array) {
              array.forEach(item=>{
                if(item.children && item.children.length){
                  if(item.path == path){
                    self.breadcrumbList = item.breadcrumbNeste;
                  }
                  getBreadcrumb(item.children);
                }
                else {
                  if(item.path == path){
                    self.breadcrumbList = item.breadcrumbNeste;
                  }
                }
              })
            }
            getBreadcrumb(this.menuLists);
          },
          lastStep() {
            this.$emit('lastStep')
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/breadcrumb.vue